<template>
  <div class="main">
    <div class="main_tabs">
      <el-tabs v-model="activeName">
        <el-tab-pane label="钢筋笼生产" name="first"></el-tab-pane>
        <el-tab-pane label="管片生产" name="second"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="main_content">
      <component :is="activeName === 'first' ? 'RebarcageIndex' : 'DuctpieceIndex'"></component>
    </div>
  </div>
</template>

<script>
import RebarcageIndex from './components/RebarcageIndex.vue'; // 钢筋笼生产
import DuctpieceIndex from './components/DuctpieceIndex.vue'; // 管片生产
  export default {
    components: {
      RebarcageIndex,
      DuctpieceIndex
    },
    data() {
      return {
        activeName: 'first'
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '@/style/layout-main.scss';

/deep/.main {
  background: none;
}
</style>